import { render } from "./NoPageFoundView.vue?vue&type=template&id=0370214a&scoped=true"
import script from "./NoPageFoundView.vue?vue&type=script&lang=js"
export * from "./NoPageFoundView.vue?vue&type=script&lang=js"

import "./NoPageFoundView.vue?vue&type=style&index=0&id=0370214a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0370214a"]])

export default __exports__